import { render, staticRenderFns } from "./NewInvoice.vue?vue&type=template&id=5db04998"
import script from "./NewInvoice.vue?vue&type=script&lang=js"
export * from "./NewInvoice.vue?vue&type=script&lang=js"
import style0 from "./NewInvoice.vue?vue&type=style&index=0&id=5db04998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports